<template>
    <div class="text-right">
        <svg
            v-if="productListBoost != 0 || searchListBoost != 0 || trademarkListBoost != 0"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="boost-icon mr-2 text-danger"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.048 8.287 8.287 0 009 9.6a8.983 8.983 0 013.361-6.867 8.21 8.21 0 003 2.48z"
            />
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 18a3.75 3.75 0 00.495-7.467 5.99 5.99 0 00-1.925 3.546 5.974 5.974 0 01-2.133-1A3.75 3.75 0 0012 18z"
            />
        </svg>

        <svg
            role="button"
            @click="
                showAdminTools = !showAdminTools;
                boostUpdated = false;
            "
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="boost-icon text-right"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75"
            />
        </svg>
        <div
            class="position-absolute admin-tools-card border rounded"
            style="min-height: 70%; width: 85%; background-color: white"
            v-if="showAdminTools == true"
        >
            <div class="text-center mt-2">
                <h5 class="mb-0">Boosty</h5>
                <div class="form-check mt-2">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        :id="'allEshops' + coloredProduct.id"
                        :name="'allEshops' + coloredProduct.id"
                        v-model="allEshops"
                    />
                    <label class="form-check-label" :for="'allEshops' + coloredProduct.id" style="font-size: 13px"
                        >Na všetkých eshopoch</label
                    >
                </div>
            </div>
            <div class="text-center mt-2">
                <small style="font-size: 12px; color: green" v-if="boostUpdated == true">Úspešne uložené</small>
            </div>

            <div class="px-3 py-3 text-center">
                <div class="text-left">
                    <label for="formControlRange" style="font-size: 15px">Vyhľadávanie</label>
                    <small style="font-size: 12px">{{ searchListBoost }}</small>
                    <input
                        min="-100"
                        max="100"
                        type="range"
                        class="form-control-range"
                        id="formControlRangeSearchList"
                        v-model="searchListBoost"
                        @input="submit"
                    />
                </div>
            </div>
            <div class="px-3 py-3 text-center">
                <div class="text-left">
                    <div class="d-flex justify-content-between">
                        <label for="formControlRange" style="font-size: 15px"
                            >Mriežka: <small style="font-size: 13px; font-weight: bold">{{ productListBoost }}</small></label
                        >
                        <svg
                            v-if="byModel == 'category'"
                            @click="putProductToFirstPlace"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="boost-icon ml-1"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M4.5 12.75l7.5-7.5 7.5 7.5m-15 6l7.5-7.5 7.5 7.5"
                            />
                        </svg>

                        <svg
                            v-if="(index > 0 || currentPageNumber > 1) && byModel == 'category'"
                            @click="shiftProductOneUp"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="boost-icon ml-1"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941"
                            />
                        </svg>
                        <svg
                            v-if="byModel == 'category'"
                            @click="shiftProductOneDown"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="boost-icon ml-1"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M2.25 6L9 12.75l4.286-4.286a11.948 11.948 0 014.306 6.43l.776 2.898m0 0l3.182-5.511m-3.182 5.51l-5.511-3.181"
                            />
                        </svg>
                        <svg
                            v-if="byModel == 'category'"
                            @click="putProductToLastPlace"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="boost-icon ml-1"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M19.5 5.25l-7.5 7.5-7.5-7.5m15 6l-7.5 7.5-7.5-7.5"
                            />
                        </svg>
                    </div>

                    <input
                        min="-100"
                        max="100"
                        type="range"
                        class="form-control-range"
                        id="formControlRangeProductList"
                        v-model="productListBoost"
                        @input="submit"
                    />
                </div>
            </div>
            <div class="px-3 py-3 text-center">
                <div class="text-left">
                    <label for="formControlRange" style="font-size: 15px">Monobrand</label>
                    <small style="font-size: 12px">{{ trademarkListBoost }}</small>
                    <input
                        min="-100"
                        max="100"
                        type="range"
                        class="form-control-range"
                        id="formControlRangeTrademarkList"
                        v-model="trademarkListBoost"
                        @input="submit"
                    />
                </div>
            </div>
            <div class="d-flex justify-content-center flex-column">
                <div class="text-left mx-4 mb-2">
                    <span v-if="elasticLogic" style="font-size: 13px">Kód: {{ coloredProduct.code }}</span>
                    <span v-if="databaseLogic" style="font-size: 13px">Kód: {{ coloredProduct.full_code }}</span>
                    <template v-if="coloredProduct.score > 0">
                        <br />
                    </template>
                    <span v-if="coloredProduct.score > 0" style="font-size: 13px">Elastic Skóre: {{ coloredProduct.score }}</span>
                    <br />
                    <!-- <span style="font-size: 13px">Uverejnené dňa: {{ coloredProduct.formatedDate.substring(0, 10) }}</span>
                    <br />
                    <span style="font-size: 13px">Naskladnené dňa: {{ coloredProduct.formatedDate.substring(0, 10) }}</span>
                    <br /> -->
                    <span style="font-size: 13px">Ks na sklade: {{ coloredProduct.stockQuantity }}</span>
                </div>
                <a :href="ephotosUrl" target="_blank" class="btn btn-primary btn-sm mx-2 my-2" style="text-decoration: none"
                    >Zobraziť v Ephotos</a
                >
                <a :href="cmsUrl" target="_blank" class="btn btn-primary btn-sm mx-2 my-2" style="text-decoration: none"
                    >Zobraziť v CMS</a
                >
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        coloredProduct: {},
        byModelId: {},
        byModel: {},
        index: {},
        elasticLogic: false,
        databaseLogic: false,
    },
    data() {
        return {
            showAdminTools: false,
            searchListBoost: this.coloredProduct.searchListBoost,
            productListBoost: this.coloredProduct.productListBoost,
            trademarkListBoost: this.coloredProduct.trademarkListBoost,
            timer: '',
            boostUpdated: false,
            allEshops: false,
        };
    },
    computed: {
        ...mapGetters({
            nextPage: 'product-list/nextPage',
        }),
        currentPageNumber() {
            if (typeof this.nextPage === 'number') {
                return this.nextPage;
            }
            if (this.nextPage) {
                return this.nextPage.split('=')[1] - 1 ?? 0;
            }
            return 1;
        },
        cmsUrl() {
            return 'https://cms-eshop.vermont-dev.eu/vrmntadm/products/colored_product/' + this.coloredProduct.id;
        },
        ephotosUrl() {
            let explodedFullCode = '';
            if (this.databaseLogic) {
                explodedFullCode = this.coloredProduct.full_code.split('-');
            }
            if (this.elasticLogic) {
                explodedFullCode = this.coloredProduct.code.split('-');
            }
            return (
                'https://ephotos.vermont.eu/articles?id=&article=' +
                explodedFullCode[0] +
                '&color=' +
                explodedFullCode[3] +
                '&brand=' +
                explodedFullCode[2] +
                '&season=' +
                explodedFullCode[1] +
                '&orderby=created_at&ordertype=desc&perpage=20'
            );
        },
    },
    methods: {
        async submit() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
                this.boostUpdated = false;
            }
            this.timer = setTimeout(() => {
                //submit form via api
                this.$http
                    .put('/colored-product/boost', {
                        all_eshops: this.allEshops,
                        search_list_boost_value: this.searchListBoost,
                        product_list_boost_value: this.productListBoost,
                        trademark_list_boost_value: this.trademarkListBoost,
                        colored_product_id: this.coloredProduct.id,
                    })
                    .then(res => {
                        this.boostUpdated = true;
                    })
                    .catch(error => {});
            }, 1000);
        },
        putProductToFirstPlace() {
            this.$http
                .put('/colored-product/boost/first-place', {
                    all_eshops: this.allEshops,
                    colored_product_id: this.coloredProduct.id,
                    category_id: this.byModelId,
                })
                .then(res => {
                    this.boostUpdated = true;
                    this.productListBoost = res.data.boost_value;
                })
                .catch(error => {
                    console.log('Nastala chyba.');
                    console.log(error);
                });
        },
        putProductToLastPlace() {
            this.$http
                .put('/colored-product/boost/last-place', {
                    all_eshops: this.allEshops,
                    colored_product_id: this.coloredProduct.id,
                    category_id: this.byModelId,
                })
                .then(res => {
                    this.boostUpdated = true;
                    this.productListBoost = res.data.boost_value;
                })
                .catch(error => {
                    console.log('Nastala chyba.');
                    console.log(error);
                });
        },
        shiftProductOneUp() {
            this.$http
                .put('/colored-product/boost/up', {
                    all_eshops: this.allEshops,
                    colored_product_id: this.coloredProduct.id,
                    category_id: this.byModelId,
                    page: this.nextPage,
                })
                .then(res => {
                    this.boostUpdated = true;
                    this.productListBoost = res.data.boost_value;
                })
                .catch(error => {
                    console.log('Nastala chyba.');
                    console.log(error);
                });
        },
        shiftProductOneDown() {
            this.$http
                .put('/colored-product/boost/down', {
                    all_eshops: this.allEshops,
                    colored_product_id: this.coloredProduct.id,
                    category_id: this.byModelId,
                    page: this.nextPage,
                })
                .then(res => {
                    this.boostUpdated = true;
                    this.productListBoost = res.data.boost_value;
                })
                .catch(error => {
                    console.log('Nastala chyba.');
                    console.log(error);
                });
        },
    },
    mounted() {
        if (this.elasticLogic) {
            this.searchListBoost = this.coloredProduct.searchListBoost;
            this.productListBoost = this.coloredProduct.productListBoost;
            this.trademarkListBoost = this.coloredProduct.trademarkListBoost;
        }

        if (this.databaseLogic) {
            this.searchListBoost = this.coloredProduct.search_list_boost_value;
            this.productListBoost = this.coloredProduct.product_list_boost_value;
            this.trademarkListBoost = this.coloredProduct.trademark_list_boost_value;
        }
    },
};
</script>

<style lang="scss" scoped>
.admin-tools-card {
    z-index: 100;
}

.btn-primary {
    background-color: rgb(69, 107, 221) !important;
    border-color: #2653d4 !important;
    &:hover {
        background-color: #2e59d9 !important;
    }
}
.boost-icon {
    width: 1.5rem;
    height: 1.5rem;
    cursor: pointer;
    transition: transform 0.2s;
    display: inline-block;
}

.boost-icon:hover {
    transform: scale(1.2);
    color: #456bdd;
}
</style>
